import { createAction } from 'redux-actions';

export const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';

export const toggleSideMenu = createAction(TOGGLE_SIDE_MENU);
